import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class TeamName extends PrimitiveValueObject<string> {
  static create(value: string): TeamName {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new TeamName(value);
  }
}
